var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"word"},[_c('video',{attrs:{"id":"video","src":_vm.url,"controls":"","preload":"auto","x5-playsinline":"","playsinline":"","webkit-playsinline":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }